import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=a856e430&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=a856e430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a856e430",
  null
  
)

export default component.exports